import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { BillingProvider } from "./lib/billing";
import Landing from "./pages/Landing";
import AuthCallback from "./pages/AuthCallback";
import AppShell from "./pages/AppShell";
import Library from "./pages/Library";
import Extract from "./pages/Extract";
import RecipeDetail from "./pages/RecipeDetail";
import RecipePrint from "./pages/RecipePrint";
import CookMode from "./pages/CookMode";
import Categories from "./pages/Categories";
import Pro from "./pages/Pro";
import ProSuccess from "./pages/ProSuccess";
import Admin from "./pages/Admin";
import Share from "./pages/Share";
import Equivalences from "./pages/Equivalences";
import ProtectedRoute from "./pages/ProtectedRoute";
import Account from "./pages/Account";
import DeleteAccount from "./pages/DeleteAccount";
import InstallPrompt from "./components/InstallPrompt";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: Detect session_id in URL fragment synchronously (not in useEffect)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/eliminar-cuenta" element={<DeleteAccount />} />
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Library />} />
        <Route path="extract" element={<Extract />} />
        <Route path="recipe/:id" element={<RecipeDetail />} />
        <Route path="categories" element={<Categories />} />
        <Route path="pro" element={<Pro />} />
        <Route path="pro/success" element={<ProSuccess />} />
        <Route path="admin" element={<Admin />} />
        <Route path="share" element={<Share />} />
        <Route path="equivalencias" element={<Equivalences />} />
        <Route path="cuenta" element={<Account />} />
      </Route>
      <Route
        path="/app/recipe/:id/print"
        element={
          <ProtectedRoute>
            <RecipePrint />
          </ProtectedRoute>
        }
      />
      <Route
        path="/app/cook/:id"
        element={
          <ProtectedRoute>
            <CookMode />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <BillingProvider>
            <AppRouter />
            <InstallPrompt />
          </BillingProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
